import { appRoutes } from 'features/app/routes/paths';

export const usersPaths = Object.freeze({
  static: {
    root: `${appRoutes.static.root}/users`,
  },
});
